import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsService } from './logic/materials.service';
import { MaterialsLogicService } from './logic/materials/materials-logic.service';
import { MaterialsDaoService } from './dao/materials-dao.service';
import { MaterialsDbDaoService } from './dao/materials-dao/materials-db-dao.service';
import { MaterialDbTableDefinition } from './dao/materials-dao/material-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: MaterialsService, useClass: MaterialsLogicService },
    { provide: MaterialsDaoService, useClass: MaterialsDbDaoService },
    { provide: MaterialDbTableDefinition },
  ],
})
export class MaterialsModule {}
